export default {"src":"/_next/static/media/DEFlag.f3d28de0.svg","height":24,"width":32};